module.exports = __webpack_public_path__ + "img/markers-generated.a657087d.svg";